"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTrackingClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const system_trace_ids_1 = require("@deliverr/system-trace-ids");
const utils_1 = require("./utils");
const EVENT_TRACKING_URL = process.env.EVENT_TRACKING_URL;
class EventTrackingClient extends base_client_1.ApiClient {
    constructor(url = EVENT_TRACKING_URL) {
        super({ baseURL: `${url}/v1/` });
    }
    async saveEvent(event) {
        try {
            let requestTraceData = {};
            const { reference } = event, eventData = __rest(event, ["reference"]);
            if (!(0, utils_1.isBrowser)()) {
                const { requestId, traceIds, decodedGids } = (0, system_trace_ids_1.fetchTraceIdContext)();
                requestTraceData = Object.assign(Object.assign(Object.assign({}, (requestId ? { requestId } : {})), (traceIds && traceIds.length > 0 ? { traceIds } : {})), (decodedGids && Object.values(decodedGids).length > 0 ? Object.assign({}, decodedGids) : {}));
            }
            const augmentedEvent = Object.assign(Object.assign(Object.assign({}, eventData), ((reference === null || reference === void 0 ? void 0 : reference.referenceId) && reference.referenceIdKey ? reference : {})), { customFields: Object.assign(Object.assign({}, (eventData.customFields || {})), requestTraceData) });
            return await this.post(`event`, augmentedEvent);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, []);
        }
    }
}
exports.EventTrackingClient = EventTrackingClient;
//# sourceMappingURL=EventTrackingClient.js.map